import Pessoa from "model/pessoa/Pessoa";

export class CachePessoas {
  static readonly instance: CachePessoas = new CachePessoas();

  private cache: {[key: string]: Pessoa} = {}
  private constructor() {}

  add(pessoa: Pessoa) {
    if (pessoa.idInstitucional) {
      this.cache[pessoa.idInstitucional] = pessoa;
    }
  }

  get(uuid?: string): Pessoa|undefined {
    return uuid === undefined 
      ? undefined
      : this.cache[uuid];
  }

  getOrEmpty(uuid: string): Pessoa {
    return this.cache[uuid] ?? {idInstitucional: uuid, nome: ''};
  }

  contains(uuid: string) {
    return this.cache[uuid] !== undefined;
  }
}
